import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ImagesService } from '@services/image-service';
import { User } from '@interfaces/models/user';
import { useTranslation } from 'next-i18next';
import styles from './product-seller-badge.module.scss';

interface SellerInterface {
  firstname: string;
  picture: {
    path: string;
    alt: string;
  };
}
interface ProductSellerBadgeProps {
  seller?: User | SellerInterface;
  className?: string;
}

const ProductSellerBadge: React.FC<ProductSellerBadgeProps> = (props) => {
  const { seller, className } = props;
  const { t: tA11y } = useTranslation('a11y');

  const hasImg: boolean = !!seller.picture.path;

  const firstLetter = useMemo<string>(() => seller?.firstname?.[0] ?? '', [seller]);

  const getImage = (path: string): string => {
    return ImagesService.buildUrl(
      path,
      {
        w: 96,
        h: 96,
        fit: 'cover',
      },
      false,
    );
  };

  if (!seller) {
    return null;
  }
  return (
    <span
      className={clsx(
        styles.sellerBadge__imageBlock,
        hasImg ? styles['sellerBadge__imageBlock--hasImage'] : styles['sellerBadge__imageBlock--noImage'],
        className ?? '',
      )}
      style={{
        backgroundImage: hasImg && `url(${getImage(seller.picture.path)})`,
      }}
      role="img"
      aria-label={tA11y('A11Y.IMAGE.SELLER_AVATAR')}
    >
      {!hasImg && firstLetter}
    </span>
  );
};

export default ProductSellerBadge;
